(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class EbProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') {
        this.initCarousel();
        return;
      }
      const productId = this.dataset.productId;
      if (this.querySelector('[data-recommendations-track]')) {
        this.initCarousel();
        return;
      }
      if (!productId) return;
      this.dataset.loaded = 'true';
      const url = `${window.Shopify?.routes?.root || '/'}recommendations/products?section_id=${this.dataset.sectionId || this.closest('[id^="shopify-section-"]')?.id?.replace('shopify-section-', '') || 'product-recommendations'}&product_id=${productId}&limit=${this.dataset.limit || 4}&intent=${this.dataset.intent || 'related'}`;
      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const section = doc.querySelector('.eb-product-recommendations');
          if (section && section.innerHTML.trim()) {
            this.innerHTML = section.innerHTML;
            this.initCarousel();
          }
        })
        .catch(() => {});
    }

    initCarousel() {
      const track = this.querySelector('[data-recommendations-track]');
      const dots = this.querySelector('[data-recommendations-dots]');
      if (!track || !dots || track.dataset.dotsReady === 'true') return;

      const slides = Array.from(track.querySelectorAll('[data-recommendations-slide]'));
      if (!slides.length) return;
      track.dataset.dotsReady = 'true';
      dots.hidden = slides.length < 2;
      dots.innerHTML = `
        <button class="eb-product-recommendations__nav-button" type="button" data-recommendations-prev>
          <span aria-hidden="true">&larr;</span>
          <span>${dots.dataset.prevLabel || 'Previous'}</span>
        </button>
        <button class="eb-product-recommendations__nav-button" type="button" data-recommendations-next>
          <span>${dots.dataset.nextLabel || 'Next'}</span>
          <span aria-hidden="true">&rarr;</span>
        </button>
      `;

      const prevButton = dots.querySelector('[data-recommendations-prev]');
      const nextButton = dots.querySelector('[data-recommendations-next]');
      let activeIndex = 0;
      const setActive = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        prevButton.disabled = activeIndex === 0;
        nextButton.disabled = activeIndex === slides.length - 1;
      };

      prevButton.addEventListener('click', () => {
        const index = Math.max(0, activeIndex - 1);
        slides[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        setActive(index);
      });

      nextButton.addEventListener('click', () => {
        const index = Math.min(slides.length - 1, activeIndex + 1);
        slides[index]?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        setActive(index);
      });

      let raf = 0;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(() => {
          const left = track.scrollLeft;
          const nearest = slides.reduce((best, slide, index) => {
            const distance = Math.abs(slide.offsetLeft - left);
            return distance < best.distance ? { index, distance } : best;
          }, { index: 0, distance: Infinity });
          setActive(nearest.index);
        });
      }, { passive: true });
      setActive(0);
    }
  }

  if (!customElements.get('eb-product-recommendations')) {
    customElements.define('eb-product-recommendations', EbProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
